import React, { useMemo, useState, useCallback, useContext, createContext } from "react";
import useExperiment from "shared/hooks/useExperiment";
import useMigrationModalQuery from "shared/components/SmsMigrationModal/useMigrationModalQuery";

export const SMS_WALL_EXPERIMENT = "SMS_WALL_MIGRATION_V2_FIX";

const SmsWallModalState = createContext();
const SmsWallModalStateUpdater = createContext();

export default function useSmsWall() {
	const [smsWallExperimentGroup] = useExperiment(SMS_WALL_EXPERIMENT);
	const { loading, hasPhone, disableSms, refetch } = useMigrationModalQuery({
		skip: smsWallExperimentGroup !== "TEST",
	});

	const showPhoneVerification = useContext(SmsWallModalState);
	const setShowPhoneVerification = useContext(SmsWallModalStateUpdater);

	const openPhoneVerification = useCallback(() => setShowPhoneVerification(true),
		[setShowPhoneVerification]);

	const closePhoneVerification = useCallback(() => setShowPhoneVerification(false),
		[setShowPhoneVerification]);

	const closePhoneVerificationAndRefetch = useCallback(() => {
		refetch();
		setShowPhoneVerification(false);
	}, [refetch, setShowPhoneVerification]);

	const showPhoneWall =
		smsWallExperimentGroup === "TEST" &&
		!loading &&
		!hasPhone &&
		!disableSms;

	return useMemo(() => ({
		showPhoneWall,
		showPhoneVerification,
		openPhoneVerification,
		closePhoneVerification,
		closePhoneVerificationAndRefetch,
	}), [
		showPhoneWall,
		showPhoneVerification,
		openPhoneVerification,
		closePhoneVerification,
		closePhoneVerificationAndRefetch,
	]);
}

// eslint-disable-next-line react/prop-types
export const SmsWallProvider = ({ children }) => {
	const [showPhoneVerification, setShowPhoneVerification] = useState(false);

	return (
		<SmsWallModalState.Provider value={showPhoneVerification}>
			<SmsWallModalStateUpdater.Provider value={setShowPhoneVerification}>
				{children}
			</SmsWallModalStateUpdater.Provider>
		</SmsWallModalState.Provider>
	);
};




// WEBPACK FOOTER //
// ./src/apps/messenger/hooks/useSmsWall.js